import { TFacility, TFixtureLabels } from "components/Fixtures/Fixtures.types";
import FacilityNavigation from "../FacilityNavigation";
import FacilityContent from "../FacilityContent";
import { useEffect, useState } from "react";
import { headerHeight } from "../FacilityNavigation/FacilityNavigation";
import { formatNumber, updateCanonicalLink } from "helpers";
import Mustache from "mustache";
import { useQueryParams } from "hooks";
import * as R from "ramda";

type TFixturesPageProps = {
  labels: TFixtureLabels;
  facilities: TFacility[];
  domain: string;
};

const FACILITY_NAME_QS = "facilityName";

function FixturesPage({ labels, facilities, domain }: TFixturesPageProps) {
  const windowUrl = window.location.href;
  const { queryParams, setQueryParams } = useQueryParams();
  const [activeFacilityIdx, setActiveFacilityIdx] = useState(0);

  useEffect(() => {
    if (facilities.length) {
      const activeFacilityTitle = R.prop(FACILITY_NAME_QS, queryParams);
      const activeFacilityIndex = facilities.findIndex(
        (facility) => facility.title === activeFacilityTitle
      );

      if (activeFacilityIndex >= 0) {
        setActiveFacilityIdx(activeFacilityIndex);
        return;
      } else {
        const newQueryParams = R.mergeLeft(queryParams, {
          [FACILITY_NAME_QS]: facilities[0].title,
        });

        setQueryParams(newQueryParams);
      }
    }

    //eslint-disable-next-line
  }, [facilities]);

  useEffect(() => {
    updateCanonicalLink(windowUrl);
  }, [windowUrl]);

  const onFacilityChange = (index: number) => {
    const fixtureElement = document.getElementById("fixture-component");

    if (fixtureElement) {
      window.scrollTo({
        top: fixtureElement.offsetTop - headerHeight,
        behavior: "smooth",
      });
    }

    setQueryParams({ [FACILITY_NAME_QS]: facilities[index].title });
    setActiveFacilityIdx(index);
  };

  const renderPrice = (
    price: number,
    fractionDigitsCount: number = 0,
    labelText?: string
  ) => {
    if (typeof price !== "number") {
      return "";
    }

    return Mustache.render(labelText || labels.priceFormatText, {
      price: formatNumber(price, {
        culture: labels.culture,
        fractionDigitsCount,
      }),
    });
  };

  const hideNavigationArrows = !Boolean(facilities?.length > 1);

  const prevFacilityIndex =
    activeFacilityIdx === 0 ? facilities.length - 1 : activeFacilityIdx - 1;
  const nextFacilityIndex =
    activeFacilityIdx === facilities.length - 1 ? 0 : activeFacilityIdx + 1;

  return (
    <div
      className={`o-fixtures ${
        labels.isWimbledon ? "o-fixtures--wimbledon" : ""
      }`}
      id="fixture-component"
    >
      <FacilityNavigation
        labels={labels}
        facilities={facilities}
        activeFacilityIdx={activeFacilityIdx}
        onClick={onFacilityChange}
        renderPrice={renderPrice}
        onPreviousClick={() => onFacilityChange(prevFacilityIndex)}
        onNextClick={() => onFacilityChange(nextFacilityIndex)}
        hideArrows={hideNavigationArrows}
      />
      <FacilityContent
        position={activeFacilityIdx + 1}
        facility={facilities[activeFacilityIdx]}
        prevFacilityName={facilities[prevFacilityIndex].index + '. ' + facilities[prevFacilityIndex].title}
        nextFacilityName={facilities[nextFacilityIndex].index + '. ' + facilities[nextFacilityIndex].title}
        onPreviousClick={() => onFacilityChange(prevFacilityIndex)}
        domain={domain}
        onNextClick={() => onFacilityChange(nextFacilityIndex)}
        labels={labels}
        renderPrice={renderPrice}
        hideArrows={hideNavigationArrows}
      />
    </div>
  );
}

export default FixturesPage;
